import { render, staticRenderFns } from "./BimTransparencyEditor.vue?vue&type=template&id=358394a2&scoped=true"
import script from "./BimTransparencyEditor.vue?vue&type=script&lang=js"
export * from "./BimTransparencyEditor.vue?vue&type=script&lang=js"
import style0 from "./BimTransparencyEditor.vue?vue&type=style&index=0&id=358394a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "358394a2",
  null
  
)

export default component.exports